const alarmDefs = {
    "WarningOrFault01": {
        "0": {
            "ID": "1",
            "Name": "Discharge over current"
        },
        "1": {
            "ID": "2",
            "Name": "Over Load"
        },
        "10": {
            "ID": "11",
            "Name": "Gfci Over"
        },
        "11": {
            "ID": "12",
            "Name": "ParallelCANFail"
        },
        "12": {
            "ID": "13",
            "Name": "Grid CT Reverse"
        },
        "13": {
            "ID": "14",
            "Name": "BUS Under Volt"
        },
        "14": {
            "ID": "15",
            "Name": "BUS Over Volt"
        },
        "15": {
            "ID": "16",
            "Name": "INV Over Current"
        },
        "2": {
            "ID": "3",
            "Name": "Bat Didconnect"
        },
        "3": {
            "ID": "4",
            "Name": "Bat Under Capacity"
        },
        "4": {
            "ID": "5",
            "Name": "Bat Low Capacity"
        },
        "5": {
            "ID": "6",
            "Name": "Bat Over Volt"
        },
        "6": {
            "ID": "7",
            "Name": "Grid Low Volt"
        },
        "7": {
            "ID": "8",
            "Name": "Grid Over Volt"
        },
        "8": {
            "ID": "9",
            "Name": "Grid Low Freq"
        },
        "9": {
            "ID": "10",
            "Name": "Grid Over Freq"
        }
    },
    "WarningOrFault02": {
        "0": {
            "ID": "17",
            "Name": "Charge over current"
        },
        "1": {
            "ID": "18",
            "Name": "Meter Comm Fail"
        },
        "10": {
            "ID": "27",
            "Name": "Bat Reverse"
        },
        "11": {
            "ID": "28",
            "Name": "BMS Comm Fail"
        },
        "12": {
            "ID": "29",
            "Name": "Bat Fault"
        },
        "13": {
            "ID": "30",
            "Name": "Grid Over Load"
        },
        "14": {
            "ID": "31",
            "Name": "Grid Phase ERR/LN Reverse"
        },
        "15": {
            "ID": "32",
            "Name": "ARC Fault"
        },
        "2": {
            "ID": "19",
            "Name": "INV Under Volt"
        },
        "3": {
            "ID": "20",
            "Name": "INV Over Volt"
        },
        "4": {
            "ID": "21",
            "Name": "INV Freq Abnor"
        },
        "5": {
            "ID": "22",
            "Name": "IGBT Temp High"
        },
        "6": {
            "ID": "23",
            "Name": "BMS sys error"
        },
        "7": {
            "ID": "24",
            "Name": "Bat Over Temp"
        },
        "8": {
            "ID": "25",
            "Name": "Bat Under Temp"
        },
        "9": {
            "ID": "26",
            "Name": "Bat Cell Unball/Relay open circuit(48V)"
        }
    },
    "WarningOrFault03": {
        "0": {
            "ID": "33",
            "Name": "bus soft fail"
        },
        "1": {
            "ID": "34",
            "Name": "inv soft fail"
        },
        "10": {
            "ID": "43",
            "Name": "CT fault"
        },
        "11": {
            "ID": "44",
            "Name": "PV short"
        },
        "12": {
            "ID": "45",
            "Name": "Byp relay fault"
        },
        "13": {
            "ID": "46",
            "Name": "System  fault"
        },
        "14": {
            "ID": "47",
            "Name": "Current Dcover"
        },
        "15": {
            "ID": "48",
            "Name": "Voltage Dcover"
        },
        "2": {
            "ID": "35",
            "Name": "bus short"
        },
        "3": {
            "ID": "36",
            "Name": "Inv short"
        },
        "4": {
            "ID": "37",
            "Name": "FAN Fault"
        },
        "5": {
            "ID": "38",
            "Name": "pviso low"
        },
        "6": {
            "ID": "39",
            "Name": "BUS relay fault"
        },
        "7": {
            "ID": "40",
            "Name": "Grid relay fault"
        },
        "8": {
            "ID": "41",
            "Name": "EPS relay fault"
        },
        "9": {
            "ID": "42",
            "Name": "Gfic fault"
        }
    },
    "WarningOrFault04": {
        "0": {
            "ID": "49",
            "Name": "MCU self-test Failure"
        }
    },
    "WarningOrFault06": {
        "0": {
            "ID": "50",
            "Name": "MOSFET Charge Derating(L BAT)"
        },
        "1": {
            "ID": "51",
            "Name": "MOSFET Charge Stop(L BAT)"
        }
    },
    "WarningOrFault10": {
        "0": {
            "ID": "52",
            "Name": "reserve"
        },
        "1": {
            "ID": "53",
            "Name": "Cell or module high voltage"
        },
        "10": {
            "ID": "62",
            "Name": "circuit fault"
        },
        "11": {
            "ID": "63",
            "Name": "Internal communication fail"
        },
        "12": {
            "ID": "64",
            "Name": "Contactor Failure"
        },
        "13": {
            "ID": "65",
            "Name": "reserve"
        },
        "14": {
            "ID": "66",
            "Name": "reserve"
        },
        "15": {
            "ID": "67",
            "Name": "reserve"
        },
        "2": {
            "ID": "54",
            "Name": "Cell or module low voltage"
        },
        "3": {
            "ID": "55",
            "Name": "Cell high temperature"
        },
        "4": {
            "ID": "56",
            "Name": "Cell low temperature"
        },
        "5": {
            "ID": "57",
            "Name": "reserve"
        },
        "6": {
            "ID": "58",
            "Name": "reserve"
        },
        "7": {
            "ID": "59",
            "Name": "Discharge high current"
        },
        "8": {
            "ID": "60",
            "Name": "Charge high current"
        },
        "9": {
            "ID": "61",
            "Name": "reserve"
        }
    },
    "WarningOrFault11": {
        "0": {
            "ID": "68",
            "Name": "reserve"
        },
        "1": {
            "ID": "69",
            "Name": "Cell or module over voltage"
        },
        "10": {
            "ID": "78",
            "Name": "circuit fault"
        },
        "11": {
            "ID": "79",
            "Name": "Internal communication fail"
        },
        "12": {
            "ID": "80",
            "Name": "Contactor Failure"
        },
        "13": {
            "ID": "81",
            "Name": "reserve"
        },
        "14": {
            "ID": "82",
            "Name": "reserve"
        },
        "15": {
            "ID": "83",
            "Name": "reserve"
        },
        "2": {
            "ID": "70",
            "Name": "Cell or module under voltage"
        },
        "3": {
            "ID": "71",
            "Name": "Cell over temperature"
        },
        "4": {
            "ID": "72",
            "Name": "Cell under temperature"
        },
        "5": {
            "ID": "73",
            "Name": "System error"
        },
        "6": {
            "ID": "74",
            "Name": "reserve"
        },
        "7": {
            "ID": "75",
            "Name": "Discharge over current"
        },
        "8": {
            "ID": "76",
            "Name": "Charge over current"
        },
        "9": {
            "ID": "77",
            "Name": "cell unbalance"
        }
    }
}


function parseAlarmData(data) {
    const InverterAlarms = [];
    const BatteryAlarms = []
    for (let i = 1; i < 12; i++) {
        const fn = "WarningOrFault" + i.toString().padStart(2, '0')
        const defs = alarmDefs[fn];
        if (!defs) {
            continue;
        }
        const c = data[fn];
        if (!c) {
            continue;
        }

        for (let j = 0; j < 16; j++) {
            const bit = (c >> j) & 1;
            const def = defs[j];
            if (bit === 1 && def) {
                InverterAlarms.push({"Code": def["ID"], "Name": def["Name"]});
                if ((def["ID"] >= 3 && def["ID"] <= 6) || (def["ID"] >= 68 && def["ID"] <= 83)) {
                    BatteryAlarms.push({"Code": def["ID"], "Name": def["Name"]});
                }
            }
        }
    }

    return {InverterAlarms, BatteryAlarms};
}

export default {
    parseAlarmData,
}